<script>
    import { onMount } from "svelte";

    import LineChart from "../../../Components/Charts/LineChart.svelte";

    import GraphPeriodIndicator from "./GraphPeriodIndicator.svelte";

    import { getDataByPeriod } from "../helpers/GraphPeriodHelper.svelte";

    export let totalPaymentsPatient = {};
    export let totalPaymentsHealthFund = {};
    export let dateFrom, dateTo;
    export let type = "";

    let isParsingData = false;
    let chartData = [];
    let labelArr = [];

    let selectedPeriod = 0;

    onMount(() => {
        (totalPaymentsPatient || totalPaymentsHealthFund) && syncData();
    });

    const syncData = async () => {
        isParsingData = true;

        if (!totalPaymentsPatient && !totalPaymentsHealthFund) {
            isParsingData = false;
            return;
        }

        const topPatientIndicatorName = `${selectedPeriod == 0 ? "Daily" : selectedPeriod == 1 ? "Weekly" : "Monthly"} total patient payments ${type}`;

        const topHealthFundIndicatorName = `${selectedPeriod == 0 ? "Daily" : selectedPeriod == 1 ? "Weekly" : "Monthly"} total health fund payments ${type}`;

        const topSumIndicatorName = `${selectedPeriod == 0 ? "Daily" : selectedPeriod == 1 ? "Weekly" : "Monthly"} total sum payments ${type}`;

        const { chartData: newPatientData, labelArr: newPatientLabelArr } =
            await getDataByPeriod(
                totalPaymentsPatient,
                selectedPeriod,
                dateFrom,
                dateTo,
                topPatientIndicatorName,
            );

        const {
            chartData: newHealthFundData,
            labelArr: newHealthFundLabelArr,
        } = await getDataByPeriod(
            totalPaymentsHealthFund,
            selectedPeriod,
            dateFrom,
            dateTo,
            topHealthFundIndicatorName,
        );

        const sumData = _syncSumData();

        const { chartData: newSumData, labelArr: newSumLabelArr } =
            await getDataByPeriod(
                sumData,
                selectedPeriod,
                dateFrom,
                dateTo,
                topSumIndicatorName,
            );

        chartData = [...newPatientData, ...newHealthFundData, ...newSumData];
        labelArr = [
            ...newPatientLabelArr,
            ...newHealthFundLabelArr,
            ...newSumLabelArr,
        ];

        isParsingData = false;
    };

    // HELPER FUNCTIONS
    const _syncSumData = () => {
        const allKeys = Array.from(
            new Set([
                ...Object.keys(totalPaymentsPatient),
                ...Object.keys(totalPaymentsHealthFund),
            ]),
        ).sort();

        const sortedPatientPayments = {};
        const sortedHealthFundPayments = {};
        const sumPayments = {};

        for (const key of allKeys) {
            sortedPatientPayments[key] = totalPaymentsPatient[key] || 0;
            sortedHealthFundPayments[key] = totalPaymentsHealthFund[key] || 0;
        }

        for (const key in sortedPatientPayments) {
            if (!sortedHealthFundPayments.hasOwnProperty(key)) {
                sortedHealthFundPayments[key] = 0;
            }
        }

        for (const key in sortedHealthFundPayments) {
            if (!sortedPatientPayments.hasOwnProperty(key)) {
                sortedPatientPayments[key] = 0;
            }
        }

        for (const key in sortedPatientPayments) {
            sumPayments[key] =
                sortedPatientPayments[key] + sortedHealthFundPayments[key];
        }

        return sumPayments;
    };
</script>

<div class="flex flex-1 flex-col p-6">
    {#if !totalPaymentsPatient && !totalPaymentsHealthFund}
        <div class="flex flex-1 items-center text-center">
            Noting to display
        </div>
    {:else if isParsingData}
        <div class="flex flex-1 items-center text-center">
            Parsing chart data
        </div>
    {:else}
        <div class="flex flex-1 items-center justify-end">
            <GraphPeriodIndicator
                bind:selectedPeriod
                onPeriodChange={syncData}
            />
        </div>

        <LineChart bind:chartData bind:labelArr />
    {/if}
</div>
